export default function (totalCharge, quantity, card) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: card.id,
    content_ids: card.id,
    content_type: "product",
  });
}
